/**
 * GPX Engine returns [lng,lat] for all cases
 */
export function reverseCoords([lng, lat]) {
  return [lat, lng];
}
